import { IconName } from '@travelata-libs/ui-kit';
import { ProductType } from '@/shared/config/pages';
import type { Tab, TabType } from '../model/types';

const DEFAULT_LEAD_TITLE = 'Не знаете куда поехать?';
const DEFAULT_LEAD_SUBTITLE = 'Эксперт поможет подобрать тур под ваш бюджет и даты';
const DEFAULT_LEAD_MODAL_SUBTITLE = 'Оставьте контакты — эксперт перезвонит \n и поможет с выбором';

const tabs: Tab[] = [
  {
    text: 'Туры',
    type: 'tours',
    icon: IconName.Beach,
    title: 'Выбирайте путешествие сами',
    leadTitle: DEFAULT_LEAD_TITLE,
    leadSubtitle: DEFAULT_LEAD_SUBTITLE,
    modalSubtitle: DEFAULT_LEAD_MODAL_SUBTITLE,
  },
  {
    text: 'Горящие',
    type: 'tours-hot',
    icon: IconName.Fire,
    title: 'Ловите туры со скидкой до 50%',
    leadTitle: DEFAULT_LEAD_TITLE,
    leadSubtitle: DEFAULT_LEAD_SUBTITLE,
    modalSubtitle: DEFAULT_LEAD_MODAL_SUBTITLE,
  },
  {
    text: 'Отели',
    type: 'hotels',
    icon: IconName.Hotel,
    title: 'Выбирайте отель сами',
    leadTitle: 'Не знаете какой отель выбрать?',
    leadSubtitle: 'Эксперт поможет подобрать отель под ваш бюджет и даты',
    modalTitle: 'Подберём отель вместе',
    searchBtnText: 'Найти отели',
    dateFieldLabel: 'Дата заезда',
    nightsFieldLabel: 'Количество ночей',
    touristsFieldLabel: 'Гости',
    nightsSummaryPrefix: 'С',
    modalSubtitle: DEFAULT_LEAD_MODAL_SUBTITLE,
  },
  {
    text: 'Ж/Д',
    type: 'railway',
    icon: IconName.Train,
    title: 'Спланируйте поездку по России сами',
    leadTitle: DEFAULT_LEAD_TITLE,
    leadSubtitle: DEFAULT_LEAD_SUBTITLE,
    dateFieldLabel: 'Дата тура',
    modalSubtitle: DEFAULT_LEAD_MODAL_SUBTITLE,
  },
];

export const PRODUCT_TYPE_TABS: Record<ProductType, TabType> = {
  [ProductType.TourOffer]: 'tours',
  [ProductType.HotelOffer]: 'hotels',
  [ProductType.RailwayTour]: 'railway',
};

export default tabs;
